import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
} from "@firebase/firestore";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router";
import { auth, batch, db } from "../lib/firebaseConfig";

export const useUpdateAISettings = () => {
  const [isLoading, setLoading] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    type: "",
    message: "",
  });

  const updateAISettings = async (updateData, user) => {
    setLoading(true);
    try {
      const docRef = doc(db, "AISettings", user.uid);
      if (user.role === "admin") {
        const response = await getDocs(collection(db, "AISettings"));
        response.docs.forEach(async (doc) => {
          batch.update(doc.ref, { aiName: updateData.aiName });
        });
        batch.commit();
      }
      await updateDoc(docRef, updateData);
      setToast({
        open: true,
        type: "success",
        message: "Save changes successfully",
      });
    } catch (error) {
      setToast({
        open: true,
        type: "error",
        message: error.message || "Someting went wrong",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { updateAISettings, isLoading, toast, setToast };
};

export const usePostAISettings = () => {
  const [isLoading, setLoading] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    type: "",
    message: "",
  });
  const navigate = useNavigate();

  const postAISettings = async (aiDocs, user, redirectTo = "/") => {
    setLoading(true);
    try {
      const docRef = doc(db, "AISettings", user.uid);
      await setDoc(docRef, aiDocs);
      setToast({
        open: true,
        type: "success",
        message: "AI settings post successfully",
      });
      navigate(redirectTo);
    } catch (error) {
      setToast({
        open: true,
        type: "error",
        message: error.message || "Someting went wrong",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { postAISettings, isLoading, toast, setToast };
};

export const useGetAISettings = () => {
  const [isLoading, setLoading] = useState(false);
  const [aiSettings, setAiSettings] = useState(null);
  const [authUser, authLoading, error] = useAuthState(auth);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const ref = doc(db, "AISettings", authUser.uid);
      const docSnap = await getDoc(ref);
      setAiSettings(docSnap.data());
      setLoading(false);
    }
    if (!authLoading) {
      if (authUser) fetchData();
      else setLoading(false); // Not signed in
    }
  }, [authLoading]);

  return { isLoading, aiSettings };
};


/* edit design feature */

export const useUpdateChatDesign = () => {
  const [isLoading, setLoading] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    type: "",
    message: "",
  });

  const updateChatDesign = async (designData, user) => {
    setLoading(true);
    try {
      const docRef = doc(db, "ChatDesign", user.uid); // Assuming "ChatDesign" is the new collection name
      await updateDoc(docRef, designData);
      setToast({
        open: true,
        type: "success",
        message: "Chat design updated successfully",
      });
    } catch (error) {
      setToast({
        open: true,
        type: "error",
        message: error.message || "Something went wrong",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { updateChatDesign, isLoading, toast, setToast };
};

export const useGetChatDesign = () => {
  const [isLoading, setLoading] = useState(true); // Initialize it to true
  const [chatDesign, setChatDesign] = useState(null);
  const [authUser, authLoading, error] = useAuthState(auth);

  const defaultDesign = {
    chatBgColor: "#fff",
    headerBgColor: "#fff",
    chatTextColor: "#000",
    userTextColor: "#000",
  };

  useEffect(() => {
    async function fetchData() {
      const ref = doc(db, "ChatDesign", authUser.uid);
      const docSnap = await getDoc(ref);
      
      // If the document exists, set the data
      if (docSnap.exists()) {
        setChatDesign(docSnap.data());
      } else {
        // If it doesn't exist, create it with default values
        await setDoc(ref, defaultDesign);
        setChatDesign(defaultDesign);
      }
      setLoading(false);
    }

    if (!authLoading) {
      if (authUser) {
        fetchData();
      } else {
        setLoading(false); // Not signed in
      }
    }
  }, [authLoading]);

  return { isLoading, chatDesign };
};

